(function () {
    if (document.querySelectorAll(".js-consent").length > 0) {

        const consent = {
            init: () => {
                consent.declineConsent();
                consent.closePopup();
            },
            declineConsent: () => {
                const declineButton = document.getElementById("button__decline");

                declineButton.addEventListener("click", () => {
                    const popup = document.getElementById("consent__popup");

                    popup.classList.add("active");
                });
            },
            closePopup: () => {
                const popup = document.getElementById("consent__popup");

                popup.addEventListener("click", (e) => {
                    if (e.target.parentNode.classList.contains("js-consent")) {
                        popup.classList.remove("active");
                    }
                });

                document.onkeydown = function (e) {
                    if (e.keyCode == 27) {
                        popup.classList.remove("active");
                    }
                };
            },
        };

        consent.init();
    }
})();
